import { WithDefaultProps } from 'browser/components/atomic-elements/higher-order-components/with-default-props'
import { GeolocationField } from 'browser/components/atomic-elements/molecules/fields/geolocation-field'

import '../../styles/_control.scss'

export const MobileGeolocationField = WithDefaultProps(GeolocationField, {
  inputClassName: 'mobile-control',
})
